/**
 * "Not connected" is only true after ticket details have arrived.
 * Missing customerId while the ticket is still loading must stay unknown
 * so the Integrations warning does not flash on a connected customer.
 */
export function resolveCustomerConnectedToTheo({
  ticketId,
  customerId,
  ticketDetailsKnown = false,
}: {
  ticketId?: string | null;
  customerId?: string | number | null;
  ticketDetailsKnown?: boolean;
}): boolean | null {
  if (!ticketId) return null;
  if (!ticketDetailsKnown) return null;
  return Boolean(String(customerId ?? "").trim());
}
